import { useTranslation } from 'react-i18next';
import type { IBiWeeksChartProps } from './IBiWeeksChartProps';

/**
 * «Створено й завершено · 8 тижнів» (прототип v4 G:L1760): пари стовпчиків висотою 180px (створено — синій, завершено — зелений, мінімум 2px),
 * підпис тижня 11px («7 тиж.» … «Цей тиж.»), легенда; підказка стовпця — «Створено N · Завершено M».
 */
export function BiWeeksChart({ weeks }: IBiWeeksChartProps) {
  const { t } = useTranslation();
  const max = Math.max(1, ...weeks.flatMap((w) => [w.created, w.done]));
  const pct = (n: number) => `${Math.round((n / max) * 100)}%`;
  return (
    <section className="bi-card" aria-label={t('biPage.createdDone')}>
      <div className="bi-card__title">{t('biPage.createdDone')}</div>
      <div className="bi-weeks">
        {weeks.map((w) => (
          <div key={w.ago} className="bi-week" title={t('biPage.weekTitle', { created: w.created, done: w.done })}>
            <div className="bi-week__bars">
              <span className="bi-week__bar" style={{ height: pct(w.created), background: 'var(--bi-blue)' }} />
              <span className="bi-week__bar" style={{ height: pct(w.done), background: 'var(--bi-green)' }} />
            </div>
            <span className="bi-week__label">{w.ago ? t('biPage.weeksAgo', { count: w.ago }) : t('biPage.thisWeek')}</span>
          </div>
        ))}
      </div>
      <div className="bi-legend">
        <span><i style={{ background: 'var(--bi-blue)' }} />{t('biPage.created')}</span>
        <span><i style={{ background: 'var(--bi-green)' }} />{t('biPage.completed')}</span>
      </div>
    </section>
  );
}
